export class DomainError extends Error {
  public readonly code: string;
  public readonly context?: Record<string, unknown>;
  public readonly timestamp: Date;

  constructor (
    message: string,
    code: string = 'DOMAIN_ERROR',
    context?: Record<string, unknown>,
  ) {
    super(message);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }

    this.name = this.constructor.name;
    this.code = code;
    this.context = context;
    this.timestamp = new Date();

    Object.setPrototypeOf(this, DomainError.prototype);
  }

  public override toString (): string {
    const parts: string[] = [
      `[${this.code}]`,
      this.message,
    ];

    if (this.context && Object.keys(this.context).length > 0) {
      parts.push(`Context: ${JSON.stringify(this.context)}`);
    }

    return parts.join(' ');
  }
}
